import React from 'react';

import { StandardLayout, OutlinedLayout } from './Layouts';

const layouts = {
  standard: StandardLayout,
  outlined: OutlinedLayout,
};

const Container = ({
  children,
  variant = 'standard',
  attributes,
  progress,
}) => {
  const component = layouts[variant];

  return component
    ? React.createElement(
        component,
        {
          attributes,
          progress,
        },
        children
      )
    : null;
};

export default Container;
